// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { Mymatch } from '../../../assets/svg';
import SportIcon from '../../../components/SportIcon';
import Formatter from '../../../i18n/formatter';
import theme from '../../../styled-components/dark';
import colors from '../../../styled-components/palette';
import { MyMatchCircleWrapper, MyMatchSelectionCircle } from '../../../styled-components/shared';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ $isBetbuilder }) =>
    $isBetbuilder
      ? css`
          flex-direction: column;
        `
      : css`
          align-items: flex-end;
        `}

  ${({ $isSimpleBet }) =>
    !$isSimpleBet
      ? css`
          background: ${colors.bluegrey900};
          box-shadow: 0 0 0.625em 0 rgba(0, 0, 0, 0.75);
          border-radius: 0.625em;
          margin-bottom: 0.625em;
          padding: 0.625em 0.625em 0.3em;
        `
      : null}
`;

const BetbuilderBetTitle = styled(MyMatchCircleWrapper)`
  font-size: 1em;
  position: relative;
  padding: 0 0 0.625em 1.5em;

  ::before,
  ::after {
    left: 0.3em;
  }

  ${({ $isFirstOutcome }) =>
    $isFirstOutcome
      ? css`
          ::before {
            content: none;
          }
        `
      : null}
`;

const IconAndMatchTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  margin-bottom: 0.625em;
`;

const StyledSportIcon = styled(SportIcon)`
  height: 1.6em;
  width: 1.6em;
  margin-right: 0.3em;
`;

const MyMatchWrapper = styled.div``;

const StyledMyMatchIcon = styled(Mymatch)`
  color: ${colors.white};
  height: 0.7em;
  margin-bottom: 0.3em;
`;

const FlexWrapper = styled.div``;

const Odds = styled.span`
  ${({ $alignRight }) =>
    $alignRight
      ? css`
          text-align: right;
        `
      : null}
`;

const FlexWrapperAndAlignItems = styled(FlexWrapper)``;

const BetInfoWrapper = styled.div`
  margin-bottom: 0.3em;
`;

const BetTitle = styled.div`
  color: ${colors.neutralgrey400};
  font-size: 0.75em;
  line-height: 1;
  margin-right: 0.3em;
  display: inline-block;
`;

const OutcomeLabel = styled.div`
  font-size: 1em;
  font-weight: bold;
  line-height: 1;
  display: inline-block;

  ${({ $hasOccured }) => css`
    color: ${$hasOccured ? theme.History.betslip.summary.greenRow : theme.History.betslip.summary.redRow};
  `}
`;

const BetbuilderOutcomeLabel = styled.div`
  font-size: 0.75em;
  color: #c1c9cf;
`;

const BetbuilderOutcomeValue = styled.div`
  font-weight: bold;
  font-size: 1em;
  color: ${colors.white};
`;

const MatchLabel = styled.div`
  font-weight: bold;
  font-size: 1em;
  color: ${colors.white};
`;

const OddsValue = styled.div`
  color: ${colors.white};
  background: ${colors.black};
  border-radius: 0.375em;
  font-size: 0.875em;
  font-weight: bold;
  padding: 0.1em 0.3em;
  margin-left: 1.25em;
  display: inline-block;
`;

const StyledSelectionCircle = styled(MyMatchSelectionCircle)`
  left: 0.3em;
`;

type HallOfFameOutcomeProps = {
  odds: number;
  matchTitle: string;
  betTitle: string;
  outcomeLabel: string;
  outcomeHasOccured: boolean;
  sportId: number;
  isBetbuilder: boolean;
  isSimpleBet: boolean;
};

const HallOfFameOutcome = ({
  odds,
  matchTitle,
  betTitle,
  outcomeLabel,
  outcomeHasOccured,
  sportId,
  isBetbuilder,
  isSimpleBet,
}: HallOfFameOutcomeProps) => {
  const betbuilderOutcomes = isBetbuilder ? outcomeLabel.split(', ') : null;

  return (
    <Wrapper $isSimpleBet={isSimpleBet} $isBetbuilder={isBetbuilder}>
      <FlexWrapperAndAlignItems>
        {isBetbuilder ? (
          <MyMatchWrapper>
            <StyledMyMatchIcon />
            {betbuilderOutcomes.map((outcome, idx) => {
              const betbuilderOutcomeParts = outcome.split(' : ');
              return (
                <React.Fragment key={`title-${idx}`}>
                  <BetbuilderBetTitle $isFirstOutcome={idx === 0}>
                    <StyledSelectionCircle />
                    {betbuilderOutcomeParts[0] ? (
                      <BetbuilderOutcomeLabel>{betbuilderOutcomeParts[0]}</BetbuilderOutcomeLabel>
                    ) : null}
                    <BetbuilderOutcomeValue>{betbuilderOutcomeParts[1]}</BetbuilderOutcomeValue>
                  </BetbuilderBetTitle>
                </React.Fragment>
              );
            })}
          </MyMatchWrapper>
        ) : (
          <>
            {!isSimpleBet ? (
              <IconAndMatchTitleWrapper>
                <StyledSportIcon sportId={sportId} />
                <MatchLabel>{matchTitle}</MatchLabel>
              </IconAndMatchTitleWrapper>
            ) : null}
            <BetInfoWrapper>
              {betTitle ? <BetTitle>{betTitle}</BetTitle> : null}
              <OutcomeLabel $hasOccured={outcomeHasOccured}>{outcomeLabel}</OutcomeLabel>
            </BetInfoWrapper>
          </>
        )}
      </FlexWrapperAndAlignItems>

      <Odds $alignRight={isBetbuilder}>
        <OddsValue>{Formatter.formatOdd(odds)}</OddsValue>
      </Odds>
    </Wrapper>
  );
};

export default HallOfFameOutcome;
